export const ET = 'CWU';
export const RAIN = 'Rainfall';
export const NEXT_IRRIGATION_DATE = 'Likely window for Next irrigation date';
export const CHANCE_OF_IRRIGATION_REQUIRED = 'Probabilty of next required irrigation occuring';
export const CHANCE_OF_ABOVE_RAIN_EACH_DAY = 'Probability of above 10mm rain each day';
export const CHANCE_OF_ABOVE_RAIN_EACH_WEEK = 'Probability of above 50mm rain each week';
